import "./ServiceHome.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion, useScroll, useTransform } from "framer-motion";

function ServiceHome() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/public/landing/services`,
          { withCredentials: true }
        );
        setServices(response.data);
      } catch (error) {
        console.error("Error fetching home data:", error.message);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="service-home-background">
      <div className="service-home-title">Our Services</div>

      <div className="sticky-scroll-section"   style={{ "--cards": services.length }}>
        {services.map((service, index) => (
          <ScrollCard key={index} service={service} index={index} />
        ))}
      </div>
    </div>
  );
}
function ScrollCard({ service, index }) {
  const { scrollYProgress } = useScroll({
    target: undefined,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, 0]); 
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  return (
    <motion.div
      className="servive-home-card"
      style={{
        zIndex: service.length - index, 
      }}
    >
      <div className="left-content">
        <div className="left-content-header">{service.title}</div>
        <div className="left-content-para">{service.description}</div>
      </div>
      <div className="right-content">
        <img src={service.image} alt={service.title} />
      </div>
    </motion.div>
  );
}


export default ServiceHome;
